import { render, staticRenderFns } from "./TransferCenterApproval.vue?vue&type=template&id=5c0ba8ee&scoped=true"
import script from "./TransferCenterApproval.vue?vue&type=script&lang=js"
export * from "./TransferCenterApproval.vue?vue&type=script&lang=js"
import style0 from "./TransferCenterApproval.vue?vue&type=style&index=0&id=5c0ba8ee&prod&scoped=true&lang=css"
import style1 from "@/styles/approval-status.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0ba8ee",
  null
  
)

export default component.exports